module.exports = __webpack_public_path__ + "img/Group 323.29720465.png";